// How a persona's stored name is shown to a person. Display only: filters, the API and the database
// keep the raw name. Persona names are free-form (Super Admin → User Types creates them), so they
// come as codes ("SCORE_CUSTOMER") or as typed names ("Buyer EAG"); both end up in sentence case.

// Names whose literal reading is unclear or carries a product brand. Keyed by the normalised name
// (upper case, words joined by "_").
const FIXED_LABELS = {
  BANKER_BRANCH: 'Bank branch user',
  BUYER_EAG: 'EAG buyer',
  EI_SUBUSER: 'Ecosystem integrator sub-user',
  PULSE_ADMIN: 'eK Pulse admin',
  SCORE_CUSTOMER: 'eK Score customer',
};

// Kept in capitals wherever they appear in a name.
const ABBREVIATIONS = new Set(['DARE', 'MFI', 'NGO', 'FPO', 'SHG', 'EI', 'EAG', 'FIL', 'OTP', 'PIN']);

const normalise = (name) => String(name || '').trim().split(/[\s_]+/).filter(Boolean);

export function personaLabel(name) {
  const words = normalise(name);
  if (words.length === 0) return '-';

  const key = words.map((word) => word.toUpperCase()).join('_');
  if (FIXED_LABELS[key]) return FIXED_LABELS[key];

  return words
    .map((word, index) => {
      const upper = word.toUpperCase();
      if (ABBREVIATIONS.has(upper)) return upper;
      if (upper === 'EK') return 'eK';
      const lower = word.toLowerCase();
      // The first word, and a product name after "eK" (eK Flux, eK Pulse), start with a capital.
      const capitalise = index === 0 || words[index - 1].toUpperCase() === 'EK';
      return capitalise ? lower.charAt(0).toUpperCase() + lower.slice(1) : lower;
    })
    .join(' ');
}

export default personaLabel;
